/**
 * Client-side slugifier. Mirrors `lib/pages.ts::slugifyPageTitle` on the
 * server so the input the user types for "new page" gets a sensible slug
 * before we POST. The server is still the source of truth — it allocates
 * a unique suffix on collision.
 */
export function slugifyPageTitle(input: string): string {
  const base = input
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
  return base || 'untitled'
}
